export default (nodeName, custom, parentNode = document.body) => {

    let $el = document.createElement(nodeName)

    if (typeof(custom) === 'string') {
        // 填充内容
        $el.innerHTML = custom
    }
    if(typeof(custom) === 'object') {
        // 填充属性
        Object.keys(custom).forEach(key => {
            $el.setAttribute(key, custom[key])
        })
    }
    
    parentNode.appendChild($el)

    return $el
}